import LandingPages from "@/views/CMS/LandingPages/LandingPages.vue";
import LandingPageCreate from "@/views/CMS/LandingPages/LandingPageCreate.vue";
import EditLandingPage from "@/views/CMS/LandingPages/EditLandingPage.vue";
const routes = [
    {
        path: "/cms/landing-pages/list",
        name: "LandingPagesList",
        component: LandingPages,
    },
    {
        path: "/cms/landing-pages/create",
        name: "LandingPageCreate",
        component: LandingPageCreate,
    },
    {
        path: "/cms/landing-pages/edit/:uuid",
        name: "EditStaticPage",
        component: EditLandingPage,
    },
];
export default routes;
